import { createFileRoute, Navigate } from "@tanstack/react-router";

import { HotelImageList } from "@/features/hotels/components/hotel/HotelImageList";
import { useHotelOffersContext } from "@/features/hotels/contexts/HotelOffersContext";

export const Route = createFileRoute(
  "/_authenticated/hotels/_hotels/_hotel-offer/$id/rooms_/$roomToken/images",
)({
  component: RouteComponent,
  staticData: {
    hotelStep: {
      presentationMode: "modal",
      stepNumber: 2,
    },
    drawer: false,
  },
});

function RouteComponent() {
  const { roomToken } = Route.useParams();
  const navigate = Route.useNavigate();
  const { data: offers } = useHotelOffersContext();

  const room = offers
    .flatMap((offer) => offer.rooms.flatMap((room) => room.options))
    .find((option) => option.roomToken === roomToken);

  if (!room) {
    return <Navigate to="../.." from={Route.fullPath} />;
  }

  return (
    <HotelImageList
      images={room.images || []}
      onImageClick={(index) =>
        navigate({ to: "./fullscreen", search: { index } })
      }
    />
  );
}
